import { createFileRoute, redirect } from '@tanstack/react-router'

// Legacy URL — the page moved to /partner. Permanent redirect keeps old links
// and search-engine index entries working.
export const Route = createFileRoute('/obsah/partner')({
  beforeLoad: ({ location }) => {
    // The query string carries the campaign parameters of old links.
    throw redirect({ href: `/partner${location.searchStr}`, statusCode: 301 })
  },
})
